import React, { useState, useEffect, useRef, useMemo } from 'react';
import { ShoppingCart, Plus, Package, Users, LayoutGrid, Trash2, X, Search, Camera, Receipt, Save,
  Minus, Image as ImageIcon, BarChart3, Settings, Printer, Clock, ArrowUpRight, Edit3,
  FileText, Download, AlertTriangle, Ban, UserCheck, Share2, Copy, AlertOctagon, RefreshCw, Truck,
  RotateCcw, ChevronLeft, ChevronRight, ScanBarcode, UserCircle2, Layers, Lock, LogIn, Menu, LogOut,
  HelpCircle, CheckSquare, Square, MapPin, Phone, PauseCircle, PlayCircle, AlertCircle, Banknote,
  CreditCard, Smartphone, BookOpen, Crown, Unlock, Globe, Wallet, History, FileCheck, Boxes, PenLine,
  CreditCard as CardIcon, Store, ArrowRightLeft, UserCog, Briefcase, FileOutput, Megaphone, UserPlus,
  Link, MonitorSmartphone, Contact, FileMinus } from 'lucide-react';
import { apiCall, generateId, formatPrice, formatDate, compressImage,
  base64ToFile, printHtmlDiv, printRawHtml, printBarcodeDiv } from '../utils/utils.js';

const VariantModal = ({ product, onClose, onSelect, hidePrice, getProductPrice }) => {
    if (!product) return null;
    const displayImage = (product.images && product.images.length > 0) ? product.images[0] : null; 
    const displayPrice = getProductPrice(product);
    return (
        <div className="fixed inset-0 bg-[#1a1a1a]/60 backdrop-blur-sm z-50 flex items-center justify-center p-4">
            <div className="bg-white w-full max-w-sm rounded-xl shadow-lg border border-[#e1e3e5] overflow-hidden">
                <div className="p-4 border-b border-[#e1e3e5] flex justify-between items-center bg-[#f6f7f8]">
                    <h3 className="font-bold text-[#1a1a1a]">Select Size</h3>
                    <button onClick={onClose} className="text-[#5c5f62] hover:text-[#1a1a1a]"><X size={18}/></button>
                </div>
                <div className="p-6">
                    <div className="flex items-center gap-4 mb-6">
                        <div className="w-16 h-16 bg-[#f6f7f8] rounded-md overflow-hidden border border-[#e1e3e5] flex-shrink-0">
                            {displayImage ? <img src={displayImage} className="w-full h-full object-contain"/> : <Package className="m-auto mt-4 text-[#c9cccf]"/>}
                        </div>
                        <div>
                            <h4 className="font-bold text-base text-[#1a1a1a] leading-tight">{product?.name}</h4>
                            {!hidePrice && <p className="text-[#008060] font-semibold mt-1">{formatPrice(displayPrice)}</p>}
                        </div>
                    </div>
                    <div className="grid grid-cols-2 gap-3">
                        {(product.variants||[]).map((variant, idx) => variant && (
                            <button key={idx} onClick={() => onSelect(variant)} className="p-3 border border-[#c9cccf] rounded-lg flex flex-col items-center hover:border-[#008060] transition-all group">
                                <span className="font-semibold text-sm text-[#1a1a1a]">{variant?.name}</span>
                                <span className={`text-[10px] font-medium uppercase mt-1 ${variant.stock > 0 ? 'text-[#008060]' : 'text-[#d82c0d]'}`}>{variant.stock > 0 ? `${variant.stock} left` : 'Sold Out'}</span>
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VariantModal;
